/**
 * @fileoverview GET handler for the "/apps/multi_language_settings/get_locales" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsMultiLanguageSettingsGetLocales } from "./constants";
import type { AppsMultiLanguageSettingsGetLocalesResult, AppsMultiLanguageSettingsGetLocalesParams } from "./types";

export const getAppsMultiLanguageSettingsLocales = reactQueryFetcherAdapter(
  appsMultiLanguageSettingsGetLocales,
  (
    signal: AbortSignal,
    params: AppsMultiLanguageSettingsGetLocalesParams
  ): Promise<AppsMultiLanguageSettingsGetLocalesResult> => {
    return fetch(
      "/apps/multi_language_settings/get_locales",
      "GET",
      { locale_ids: params.localeIds, include_all_active: params.includeAllActive },
      { signal }
    );
  }
);
